import React, { useState, useCallback } from "react";
import CreateOrderTabs from "./CreateOrderTabs";
import OrderList from "./OrderList";
import { toast } from "../../../components/AppToast";
import { loadOrdersFromStorage, saveOrdersToStorage } from "./orderStorage";

/**
 * OMS Order: list view with key columns, and ASN-style tabbed create/edit/view form.
 */
export default function OrderManagement() {
  const [listVersion, setListVersion] = useState(0);
  const [mode, setMode] = useState("list"); // list | create | view | edit
  const [activeOrder, setActiveOrder] = useState(null);

  const bumpList = useCallback(() => {
    setListVersion((v) => v + 1);
  }, []);

  const goToList = useCallback(() => {
    setMode("list");
    setActiveOrder(null);
    bumpList();
  }, [bumpList]);

  const handleSubmit = async (data, editId) => {
    const list = loadOrdersFromStorage();
    if (editId) {
      const idx = list.findIndex((x) => x._id === editId);
      if (idx >= 0) {
        list[idx] = { ...list[idx], ...data, _id: editId };
      } else {
        list.push({ ...data, _id: editId });
      }
    } else {
      list.unshift(data);
    }
    saveOrdersToStorage(list);
    toast.success(editId ? "Order updated" : "Order saved");
    goToList();
  };

  const title =
    mode === "create"
      ? "Create Order"
      : mode === "view"
        ? "View Order"
        : mode === "edit"
          ? "Edit Order"
          : "Orders";

  return (
    <div className="card shadow-lg main-card" style={{ position: "relative" }}>
      <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
        <h4 className="mb-0 h6 fw-semibold">{title}</h4>
      </div>

      {(mode === "create" || mode === "view" || mode === "edit") && (
        <nav aria-label="breadcrumb" className="px-3 py-2 border-bottom bg-light mb-2">
          <ol className="breadcrumb mb-0 align-items-center">
            <li className="breadcrumb-item">
              <button
                type="button"
                className="btn btn-link p-0 text-decoration-none text-muted"
                onClick={goToList}
              >
                Orders
              </button>
            </li>
            <li className="breadcrumb-item active fw-semibold text-primary" aria-current="page">
              {mode === "create" && "Create"}
              {mode === "view" && "View"}
              {mode === "edit" && "Edit"}
            </li>
          </ol>
        </nav>
      )}

      <div className="card-body">
        {mode === "list" && (
          <OrderList
            refreshKey={listVersion}
            onCreateClick={() => {
              setActiveOrder(null);
              setMode("create");
            }}
            onViewOrder={(row) => {
              setActiveOrder(row);
              setMode("view");
            }}
            onEditOrder={(row) => {
              setActiveOrder(row);
              setMode("edit");
            }}
          />
        )}

        {mode === "create" && (
          <CreateOrderTabs
            onCancel={goToList}
            onSubmit={handleSubmit}
            isEdit={false}
            viewOnly={false}
          />
        )}

        {(mode === "view" || mode === "edit") && activeOrder && (
          <CreateOrderTabs
            initialValues={activeOrder}
            onCancel={goToList}
            onSubmit={handleSubmit}
            isEdit={mode === "edit"}
            viewOnly={mode === "view"}
          />
        )}
      </div>
    </div>
  );
}
